import {useTranslation} from "react-i18next";
import Logo from '../../Assets/images/logo/connectcaremintgreen.png';
import {Link, useNavigate, useParams} from "react-router-dom";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import * as yup from "yup";
import toast from "react-hot-toast";
import {PrimaryButton} from "../../Components/Buttons/PrimaryButton";
import {TextInput} from "../../Components/Form/TextInput";
import {useBoundStore} from "../../Store/store";
import {PasswordInput} from "../../Components/Form/PasswordInput";

export const EnterNewPassword = () => {
    const {
        token
    } = useParams();

    const { t } = useTranslation();
    const navigate = useNavigate();

    if(token === undefined || token === null) {
        navigate('/');
    }

    const resetPassword = useBoundStore(state => state.resetPassword);

    const schema = yup
        .object({
            code: yup.string().length(8).required(),
            password: yup.string().min(8).required(),
            confirm_password: yup.string().oneOf([yup.ref('password'), null], t('auth.passwords_must_match'))
        })
        .required()

    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(schema)
    })

    const onSubmit = (data) => {
        const transformedData = {
            token: token,
            code: data.code,
            password: data.password,
            password_confirmation: data.confirm_password
        }

        resetPassword(transformedData).then((res) => {
            if (res?.message === 'invalid_code') {
                toast.error(t('auth.invalid_code'));
                return;
            }

            if (res?.message === 'invalid_token') {
                toast.error(t('auth.invalid_request'));
                return;
            }

            if (res?.message === 'code_expired') {
                toast.error(t('auth.code_expired'));
                return;
            }

            toast.success(t('auth.password_changed'));
            navigate('/');
        });
    }


    return (
        <div className={'flex flex-col justify-center h-screen w-full'}>
            <div className={'p-3 text-center'}>
                <img src={Logo} alt={'Logo for connect care mint green'} className={'max-h-16 mx-auto'}/>
            </div>
            <div className={'p-3 w-full max-w-[80%] md:max-w-[50%] mx-auto'}>
                <form className="w-full" onSubmit={handleSubmit(onSubmit)}>
                    <div className={'mb-4'}>
                        <TextInput
                            label={'code'}
                            name={'code'}
                            register={register}
                            translationIndex={'general.fields.code'}
                            errors={errors}
                        />
                    </div>

                    <div className={'mb-4'}>
                        <PasswordInput
                            label={'password'}
                            name={'password'}
                            register={register}
                            translationIndex={'general.fields.password'}
                            errors={errors}
                        />
                    </div>

                    <div className={'mb-4'}>
                        <PasswordInput
                            label={'confirm_password'}
                            name={'confirm_password'}
                            register={register}
                            translationIndex={'general.fields.confirm_password'}
                            errors={errors}
                        />
                    </div>

                    <div className={'mt-4 mb-1'}>
                        <PrimaryButton type={'submit'}>
                            {t('auth.reset_password.submit_button')}
                        </PrimaryButton>
                    </div>
                    <div className={'text-center mt-3'}>
                        <Link className={'text-primary hover:text-opacity-50 transition-all duration-300'} to={'/'}>
                            {t('auth.reset_password.back_to_login')}
                        </Link>
                    </div>
                </form>
            </div>
        </div>
    )
}